import {
  GET_MY_COMPANY_REQUEST,
  GET_MY_COMPANY_SUCCESS,
  GET_MY_COMPANY_FAILURE,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: true,
    data: null,
  };
};

const initialState = getInitialState();

const myCompany = (state = initialState, action) => {
  const types = {
    [GET_MY_COMPANY_REQUEST]: () => ({
      ...state,
    }),
    [GET_MY_COMPANY_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      data: action.response,
    }),
    [GET_MY_COMPANY_FAILURE]: () => ({
      isLoading: false,
      data: null,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default myCompany;
